import { Pipe, PipeTransform } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';
import { format, formatDistanceToNow, isToday, isTomorrow, isYesterday } from 'date-fns';

export interface DateFormatPipeOptions {
  plainDate?: boolean;
  dateTimeShort?: boolean;
  time?: boolean;
  dayOfWeek?: boolean;
  isSafe?: boolean; // is really a date string
  addPrefix?: boolean;
}

@Pipe({
  name: 'spDateFormat',
})
export class SpDateFormatPipe implements PipeTransform {
  transform(input?: string, options?: DateFormatPipeOptions) {
    // if somehow not a string
    if (!input || typeof input !== 'string') {
      return input;
    }

    // string is a number !! timestamp also go here !!
    if (!isNaN(input as AnyType)) {
      return input;
    }

    // this is clearly a workaround, need a proper way to detect that
    if (options?.isSafe !== true && input.replace(/[^0-9]/g, '').length < 6) {
      return input;
    }

    try {
      if (isNaN(Date.parse(input))) {
        return input;
      }

      const value = new Date(input);
      if (!(value instanceof Date && isFinite(value as unknown as number))) {
        return input;
      }

      if (options?.plainDate) {
        return format(value, 'd MMM yyyy');
      }

      if (options?.dateTimeShort) {
        return this.formateDateTimeShort(value, options?.addPrefix);
      }

      if (isToday(value)) {
        if (!options?.time || (value.getHours() === 0 && value.getMinutes() === 0)) {
          return $localize`Today`;
        }
        return formatDistanceToNow(value, { addSuffix: true });
      }

      if (!options?.time && isTomorrow(value)) {
        return $localize`Tomorrow`;
      }

      if (!options?.time && isYesterday(value)) {
        return $localize`Yesterday`;
      }

      if (options?.time && !options.dayOfWeek) {
        return format(value, 'd MMM yyyy | HH:mm');
      }

      if (options?.dayOfWeek && !options.time) {
        return format(value, 'iii | d MMM yyyy');
      }

      if (options?.dayOfWeek && options.time) {
        return format(value, 'iii | d MMM yyyy | HH:mm');
      }

      return format(value, 'd MMM yyyy');
    } catch (err) {
      return input;
    }
  }

  private formateDateTimeShort(date: Date, addPrefix = true) {
    if (isToday(date) && addPrefix) {
      return $localize`Today` + ` | ${this.formateTime(date)}`;
    }

    if (isTomorrow(date) && addPrefix) {
      return $localize`Tomorrow` + ` | ${this.formateTime(date)}`;
    }

    if (isYesterday(date) && addPrefix) {
      return $localize`Yesterday` + ` | ${this.formateTime(date)}`;
    }

    return format(date, 'd MMM yy | HH:mm');
  }

  private formateTime(date: Date) {
    return format(date, 'HH:mm');
  }
}
